import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './ui/LoadingSpinner';

const VendorRoute = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // التحقق من أن المستخدم له دور vendor
  const isVendor = user?.roles?.some(role => role.name === 'vendor');
  
  if (!isVendor) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default VendorRoute;